module.exports = __webpack_public_path__ + "static/liva-convert-detail6-fdbb1fa39e8125e40952552d0613db96.png";